import * as React from 'react';
import { useChatStyles } from './Chat.styles';
import { useSelector } from 'react-redux';
import { careerStateSelector } from '@careerhub/common';
import { CareerCopilotChat } from '@careerhub/copilotchat';

export const Chat = () => {
  const styles = useChatStyles();
  const { isChatOpen } = useSelector(careerStateSelector);
  return !isChatOpen ? (
    <></>
  ) : (
    <div className={styles.blade}>
      <CareerCopilotChat />
    </div>
  );
};
